function calculatePathControlPoints(data, fromIcon, toIcon, iconPositions, circleR,
  rPosition){

  // retrieve positions
  const r1 = iconPositions[fromIcon][0];
  const r2 = iconPositions[toIcon][0];
  const theta1 = iconPositions[fromIcon][1];
  const theta2 = iconPositions[toIcon][1];

  const start = [r1, theta1]
  const end = [r2, theta2]

  // reduce the inbetweenPoints in the middle circle to 1
  const inbetweenPoints = (data.filter(d => +d.ID === fromIcon)[0]['typenr'] === '1' && r1 === r2)
    ? [calcInbetweenPoints(start, end, circleR, rPosition)[0]]
    : calcInbetweenPoints(start, end, circleR, rPosition);

  const points = [start, ...inbetweenPoints, end]

  return points;
}

function calcInbetweenPoints(start, end, circleR, rPosition){
  const startR = start[0];
  const startTheta = start[1];
  const endR = end[0];
  const endTheta = end[1];

  let thetaDiff = endTheta - startTheta;
  if(thetaDiff > Math.PI){
    thetaDiff = thetaDiff - 2*Math.PI;
  }
  if(thetaDiff < -Math.PI){
    thetaDiff = thetaDiff + 2*Math.PI;
  }

  const thetaStep = 0.15
  const noOfInbetweenPoints = Math.abs(thetaDiff) / thetaStep;

  let inbetweenPoints = [];
  for(let i=2;i<noOfInbetweenPoints-1;i++){

    // let newCircleR = (2*circleR) * (1 - Math.abs(thetaDiff) / Math.PI) + 10 + circleR
    // if(startR === endR){
    //   newCircleR = (2*circleR) * (Math.abs(thetaDiff) / Math.PI) + 5
    // }

    const newCircleR = 2*circleR + rPosition;
    // // check if a link is to an icon in a more inner or a more outer circle
    const R = (startR < endR)
      ? startR + 2*circleR + rPosition
      : startR - 2*circleR + rPosition;

    inbetweenPoints.push([R, startTheta + Math.sign(thetaDiff) * i * thetaStep])
  }

  return inbetweenPoints;
}

export {
  calculatePathControlPoints
}
